import { ErrorHandler, NgModule, provideAppInitializer, provideBrowserGlobalErrorListeners, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import * as Sentry from '@sentry/angular';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';

const sentryProviders = environment.sentryDsn
  ? [
      { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false }) },
      { provide: Sentry.TraceService, deps: [Router] },
      provideAppInitializer(() => {
        inject(Sentry.TraceService);
      }),
    ]
  : [];

@NgModule({
  declarations: [App],
  imports: [BrowserModule, CommonModule, AppRoutingModule, RouterOutlet],
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    ...sentryProviders,
  ],
  bootstrap: [App],
})
export class AppModule {}
